import { UserException } from '@/domain/user/exception/UserException'

export class InvalidUserException extends UserException {
}
